<template>
  <div id="app-wdig">
    <!-- <loading v-if="items.length == 0 || nav.length == 0"></loading> -->
    <loading v-if="items.length == 0"></loading>
    <div class="search">
      <form>
        <label id="item-name" class="sr-only">Item Name</label>
        <VueSimpleSuggest 
          v-model="searchTerm" 
          :list="aliases" 
          :filter-by-query="true" 
          :prevent-submit="false"
          value-attribute="name" 
          display-attribute="name" 
          placeholder="Type in your item to search"
        ></VueSimpleSuggest>
        <button @click.stop.prevent="$router.push('/search-results')">Search</button>
      </form>
    </div>
    <div class="fakeTabs">
      <router-link to="/a-z">A to Z List</router-link>
      <router-link to="/categories">Categories</router-link>
    </div>
    <router-view v-bind="routeProps" />
  </div>
</template>

<script>
  const VueSimpleSuggest = require('vue-simple-suggest/dist/cjs');
  import 'vue-simple-suggest/dist/styles.css'
  import Loading from '@/components/Loading';

  export default {
    name: 'App',
    data() {
      return {
        searchTerm: ''
      }
    },
    props: {
      'nav' : Array, 
      'items' : Array, 
      'aliases' : Array, 
      'rates' : Array
    },
    mounted() {
      // ADA fix for vue-simple-suggest form wrapper
      const inputWrapper = document.querySelector('form .input-wrapper')
      if (inputWrapper) inputWrapper.setAttribute('aria-labelledby','item-name')
    },
    computed: {
      routeProps: function() {
        const route = this.$route.name;
        let props = {};

        if (route.indexOf('Cat') > -1) { 
          props.nav = this.nav;
        }
        if (route == 'AtoZList') { 
          props.items = this.items;
        }
        if (route == 'SearchResults') { 
          props.aliases = this.aliases;
          props.searchTerm = this.searchTerm; 
        } 
        if (route == 'ItemByID' || route == 'ItemByName') { 
          props.items = this.items;
          props.aliases = this.aliases;
          props.rates = this.rates; 
        }
        
        return props;
      }
    },
    components: {
      VueSimpleSuggest,
      Loading
    }
  }
</script>

<style>
  [v-cloak]{
    display:none;
  }
</style>